/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Status/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'



/** @type {import('Simple/types.js').View} */
export default function Status({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Payors/Content/Payors/Payor/Content/Content/Profile/InsurancePaymentAccount/Content/Status"
  
}) {
let insuredInsuranceSubscriptionActiveValueData = fromData.useDataValue({ viewPath,
context: 'insured',
path: 'insurance_subscription.active',
})
let insuredInsuranceSubscriptionActiveValueData1 = fromData.useDataValue({ viewPath,
context: 'insured',
path: 'insurance_subscription.active',
})
  return (<React.Fragment
>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
 alignSelf="center"
 type={insuredInsuranceSubscriptionActiveValueData ? "green" : "red"}
 data="insured.insurance_subscription.active"
>
{childProps => (
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 text={insuredInsuranceSubscriptionActiveValueData1 ? "Active" : "Inactive"}
 data="insured.insurance_subscription.active"
/>
)}
</TysiaTag>
{children}
</React.Fragment>)
}